import axios from "axios";
import CONFIG from "../config";
import { getUserInfo } from './cookie';

const setApiUrl = url => {
    if (CONFIG.back_domain) return `http://${CONFIG.back_domain}:${CONFIG.back_port}${url}`
    else return `${url}`
}

const config = {
    headers: { 'Content-Type': 'application/json' },
    'withCredentials': true
};

// 공통 에러 처리 함수
const handleError = (error, method, url, body = null) => {
    console.error(`${method} 요청 실패:`, error);
    console.error('URL:', setApiUrl(url));
    if (body) console.error('Body:', body);
    console.error('에러 응답:', error.response);
    
    // 401, 403 에러일 때 로그인 상태 확인
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        const userInfo = getUserInfo();
        const isLoggedIn = userInfo && Object.keys(userInfo).length > 0;
        
        // 로그인이 안되어있으면 로그인 페이지로 이동
        if (!isLoggedIn) {
            window.location.href = '/login';
            return;
        }
    }
    
    // 모든 에러는 에러 객체 반환
    return {
        code: 'error',
        message: error.response?.data?.message || error.message || '요청에 실패했습니다.',
        error: error
    };
};

const get = async (url, params = {}) => {
    try {
        const result = await axios.get(setApiUrl(url), { ...config, params });
        return result.data;
    } catch (error) {
        return handleError(error, 'GET', url);
    }
};

const post = async (url, body) => {
    try {
        console.log('body', body);
        const result = await axios.post(setApiUrl(url), body, config);
        return result.data;
    } catch (error) {
        return handleError(error, 'POST', url, body);
    }
}

const put = async (url, body) => {
    try {
        const result = await axios.put(setApiUrl(url), body, config);
        return result.data;
    } catch (error) {
        return handleError(error, 'PUT', url, body);
    }
}

const remove = async (url, body) => {
    try {
        const result = await axios.delete(setApiUrl(url), config);
        return result.data;
    } catch (error) {
        return handleError(error, 'DELETE', url);
    }
}

export { get, post, put, remove };
